import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Loader } from '@screentone/core';
import ChartService from '../../../util/ChartService';
import NewEnginePrintCrop from '../../chartview/charts/NewEnginePrintCrop';
import * as chartActions from '../../../actions/chart-actions';
import renderOptions from '../../../util/renderOptions';
import ThemeSelector from '../../chartview/charts/chartThemes';
import ExportButtons from '../ExportButtons';
import { PRINT_ID } from '../constants';

const PrintChartView = ({ activeDoc, requestChart, receiveChart }) => {
  const id = window.location.pathname.split('/').pop();
  const options = activeDoc?.chart ? renderOptions(activeDoc, null, null, null, null, true) : {};

  useEffect(() => {
    async function setupCharts() {
      if (id) {
        try {
          requestChart(id);
          const data = await ChartService.fetchPrintChart(id);
          receiveChart(null, JSON.parse(data.text));
        } catch (networkError) {
          receiveChart(networkError.message, null);
        }
      }
    }

    setupCharts();
  }, []);

  return activeDoc?.chart && activeDoc.chart?.sizes[PRINT_ID] ? (
    <>
      <ThemeSelector theme="print-wsj" />
      <NewEnginePrintCrop id={PRINT_ID} chart={activeDoc.chart} options={options} />
      <ExportButtons />
    </>
  ) : (
    <Loader />
  );
};

const mapStateToProps = (state) => ({
  activeDoc: state.documents.active ? state.documents.items[state.documents.active] : null,
});

const mapDispatchToProps = {
  requestChart: chartActions.requestChart,
  receiveChart: chartActions.receiveChart,
};

const ChartView = connect(mapStateToProps, mapDispatchToProps)(PrintChartView);
export { ChartView };
